const initialState = {
  count: 0,
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const GetListCustomerData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_CUSTOMER_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_LIST_CUSTOMER_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_LIST_CUSTOMER_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        count: action.payload.response.data?.count ?? 0,
        data: action.payload.response.data?.result ?? null,
      };
    default:
      return state;
  }
};

// export const SingleCustomerData = (state = initialState, action) => {
//   switch (action.type) {
//     case "GET_A_CUSTOMERS_PENDING":
//       return {
//         ...state,
//         isLoading: true,
//         isRejected: false,
//         isFulfilled: false,
//       };
//     case "GET_A_CUSTOMERS_REJECTED":
//       return {
//         ...state,
//         isLoading: false,
//         isRejected: true,
//         errorMessage: action.payload.response.data ?? null,
//       };
//     case "GET_A_CUSTOMERS_FULFILLED":
//       return {
//         ...state,
//         isLoading: false,
//         isFulfilled: true,
//         data: action.payload.response.data ?? null,
//       };
//     default:
//       return state;
//   }
// };

// export const AddCustomer = (state = initialState, action) => {
//   switch (action.type) {
//     case "ADD_CUSTOMERS_PENDING":
//       return {
//         ...state,
//         isLoading: true,
//         isRejected: false,
//         isFulfilled: false,
//       };
//     case "ADD_CUSTOMERS_REJECTED":
//       return {
//         ...state,
//         isLoading: false,
//         isRejected: true,
//         errorMessage: action.payload.response.data ?? null,
//       };
//     case "ADD_CUSTOMERS_FULFILLED":
//       return {
//         ...state,
//         isLoading: false,
//         isFulfilled: true,
//         data: action.payload.response.data ?? null,
//       };
//     default:
//       return state;
//   }
// };

// export const EditCustomer = (state = initialState, action) => {
//   switch (action.type) {
//     case "EDIT_CUSTOMERS_PENDING":
//       return {
//         ...state,
//         isLoading: true,
//         isRejected: false,
//         isFulfilled: false,
//       };
//     case "EDIT_CUSTOMERS_REJECTED":
//       return {
//         ...state,
//         isLoading: false,
//         isRejected: true,
//         errorMessage: action.payload.response.data ?? null,
//       };
//     case "EDIT_CUSTOMERS_FULFILLED":
//       return {
//         ...state,
//         isLoading: false,
//         isFulfilled: true,
//         data: action.payload.response.data ?? null,
//       };
//     default:
//       return state;
//   }
// };
